import React, { Component } from 'react';
import {
  Button, Popover, Position
} from '@blueprintjs/core';
import { observable } from 'mobx';
import 'fullcalendar';
import 'fullcalendar-scheduler';
import 'fullcalendar/dist/fullcalendar.css';
import 'fullcalendar-scheduler/dist/scheduler.css';
import { inject, observer } from 'mobx-react';
import { router } from '../../App';
import SearchDateRangePicker from 'components/SearchDateRangePicker';
import 'jquery-ui/ui/widgets/draggable';
import moment from 'moment-timezone';
import { formatDateRange } from 'helpers/dateRange';
import { makeJobCardsDraggable } from 'helpers/dispatchDraggable';
import { TIMELINE_MIN_LAYOUT_MINUTES } from 'helpers/timelineLayout';
import debounce from 'services/debounce';
import Footer from '../../components/Footer';
import Pagination from 'components/Pagination';

@inject('jobStore', 'viewStore') @observer
class IncompleteJob extends Component {

  listRef = React.createRef();

  componentDidMount() {
    makeJobCardsDraggable(this.listRef.current);
  }

  componentDidUpdate() {
    makeJobCardsDraggable(this.listRef.current);
  }

  // What the calendar needs when a card is dropped on it. A job with one
  // assignment moves that assignment (like dragging on the timeline);
  // otherwise the job itself moves (like dragging in week view).
  dropData(job) {
    const attrs = job.attributes;
    const assignments = attrs.assignments || [];
    const single = assignments.length === 1 ? assignments[0] : null;
    return {
      id: single ? single.id : job.id,
      job_id: job.id,
      title: attrs.title,
      start_date: attrs.start_date,
      end_date: attrs.end_date,
      status: (single && single.status) || attrs.status,
      eventNumber: attrs.event_number,
      serviceType: attrs.service_type || {},
      clientName: attrs.client_name,
      fullAddress: attrs.location && attrs.location.full_address,
      technicianName: attrs.technician_names || '',
      priority: (attrs.priority || '').toLowerCase(),
      // Stays on the calendar through the refetch after a drop (the board
      // removes it once the saved job comes back).
      stick: true,
      // Lets the calendar size the dropped card before it refetches (at least
      // the timeline's minimum layout length, so it can't overlap).
      duration: moment.duration(Math.max(
        moment(attrs.end_date).diff(moment(attrs.start_date)),
        TIMELINE_MIN_LAYOUT_MINUTES * 60 * 1000
      )).toISOString(),
      // Week view moves each assignment, keeping its technician and status.
      assignments: assignments.map((a) => ({ id: a.id, user_id: a.user_id, status: a.status })),
    };
  }

  renderDateTime(startDate, endDate) {
    const startDateFormatted = moment(startDate).format("MMM D, YY h:mma");
    const endDateFormatted = moment(endDate).format("MMM D, YY h:mma");
    const combined = moment(startDate).format("MMM D, YY h:mma") + " - " + moment(endDate).format("h:mma");
    const sameStartAndEnd = moment(startDate).format("MM/DD/YYYY") === moment(endDate).format("MM/DD/YYYY");

    if (sameStartAndEnd) {
      return combined;
    } else{
      return `${startDateFormatted} - ${endDateFormatted}`;
    }
  }

  // Wait for a pause in typing before searching.
  searchByTerm = debounce((term) => {
    this.props.viewStore.incompleteJobSearch = {
      ...this.props.viewStore.incompleteJobSearch,
      term: term,
      page: 1,
    };
    this.props.jobStore.loadIncompleteJobs();
  }, 300);

  onTermChange(e) {
    this.searchByTerm(e.target.value);
  }

  onPaginationChange(newPage) {
    this.props.viewStore.incompleteJobSearch = {
      ...this.props.viewStore.incompleteJobSearch,
      page: newPage,
    };
    this.props.jobStore.loadIncompleteJobs();
  }

  onDateRangeChange(range) {
    let {
      props: {
        jobStore,
        viewStore: {
          incompleteJobSearch
        }
      }
    } = this;
    this.props.viewStore.incompleteJobSearch = {
      ...incompleteJobSearch,
      where: {
        ...incompleteJobSearch.where,
        start_date: { 
          gte: moment(range[0]).startOf('day').unix()
        },
        end_date: { 
          lte: moment(range[1]).endOf('day').unix()
        }
      },
      page: 1,
    }
    
    jobStore.loadIncompleteJobs();
  }

  render() {
    let {
      jobStore: {
        incompleteJobs: {
          objects,
          isLoading,
          meta
        }
      },
      viewStore: {
        incompleteJobSearch: {
          where,
          term
        }
      }
    } = this.props;

    let startDate = moment.unix(parseInt(where.start_date.gte)).toDate();
    let endDate = moment.unix(parseInt(where.end_date.lte)).toDate();

    return(
      <div>
        <div className="unassigned-job-sidebar" >
          <div className="usg-panel__header">
            <h2 className="usg-panel__title">Incomplete jobs</h2>
          </div>

          <div className="filter-bar usg-filters">
            <div className="filter-bar__cell">
              <div className="bp3-input-group usg-filters__search">
                <span className="bp3-icon bp3-icon-search"></span>
                <input
                  className="bp3-input"
                  type="search"
                  placeholder="Job title, number or client"
                  aria-label="Search incomplete jobs"
                  onChange={this.onTermChange.bind(this)}
                  defaultValue={term}
                  dir="auto" />
              </div>
            </div>
            <div className="filter-bar__cell">
              <Popover
                minimal={true}
                content={
                  <SearchDateRangePicker
                    startDate={startDate}
                    endDate={endDate}
                    onChange={this.onDateRangeChange.bind(this)}
                  />
                }
                position={Position.BOTTOM_LEFT}
                usePortal={true} >
                <Button
                  className="filter-date"
                  icon="calendar"
                  rightIcon="caret-down"
                  text={formatDateRange(startDate, endDate)}
                />
              </Popover>
            </div>
          </div>

          {objects.length !== 0 && meta && meta.total_pages > 1 &&
            <Footer>
              <div className="bp3-navbar-group responsive-pagination bp3-align-left scrollable-pagination">
                <Pagination
                  value={meta.page}
                  total={meta.total_pages}
                  onChange={this.onPaginationChange.bind(this)}
                />
              </div>
            </Footer>
          }

          <div className="incomplete-job-wraper" ref={this.listRef}>
            {
              isLoading &&
              <div className="unassg-loading">
                <div className="block">
                  <span className="skeleton-box" style={{ width: '80%' }}></span>
                  <span className="skeleton-box" style={{ width: '90%' }}></span>
                  <span className="skeleton-box" style={{ width: '100%' }}></span>
                  <span className="skeleton-box" style={{ width: '70%' }}></span>
                </div>
                <div className="block">
                  <span className="skeleton-box" style={{ width: '80%' }}></span>
                  <span className="skeleton-box" style={{ width: '90%' }}></span>
                  <span className="skeleton-box" style={{ width: '100%' }}></span>
                  <span className="skeleton-box" style={{ width: '70%' }}></span>
                </div>
                <div className="block">
                  <span className="skeleton-box" style={{ width: '80%' }}></span>
                  <span className="skeleton-box" style={{ width: '90%' }}></span>
                  <span className="skeleton-box" style={{ width: '100%' }}></span>
                  <span className="skeleton-box" style={{ width: '70%' }}></span>
                </div>
              </div>

            }
            {
              !isLoading && objects.length === 0 && <div>
                <div className="caughtup-message">
                  <img src="../calender-1 1.svg" alt="" width="120" />
                  <strong>No incomplete jobs in this range</strong>
                  <span>Try a wider date range or a different search.</span>
                </div>
              </div>
            }
            {
              !isLoading && objects.length > 0 && objects.map((job) => {
                return (
                  <div
                    className="card usg-card incomplete-events fc-events"
                    key={job.id}
                    data-event={JSON.stringify(this.dropData(job))}
                    title="Click to open, or drag onto the calendar to reschedule"
                    onClick={(e) => {
                      if (e.currentTarget.dataset.dragging) return;
                      router.navigate(`/dashboard/jobs/${job.id}`);
                    }}
                  >                                        
                    <div className="card-body unsg-card">
                      <div className='card-top'>
                        <div className='event-number'>#{job.attributes && job.attributes.event_number}</div>
                        <div className='event-tag' style={{ backgroundColor: `#${job.attributes.service_type.color}`, color: '#ffffff' }}>{job.attributes.service_type && job.attributes.service_type.name} {job.attributes && job.attributes.service_agreement && job.attributes.service_agreement.id && <span className='bp3-icon-standard bp3-icon-repeat unassigned-repeat-icon repeat-icon'></span>} </div>
                      </div>
                      <div className='fc-title'>{job.attributes.title}</div>                      
                      <div className='card-row'>
                        <div className="client-name">{job.attributes.client_name}</div>
                        <div className="full-address">{job.attributes.location && job.attributes.location.full_address}</div>
                      </div>  
                      <div className='card-bottom'> 
                        <div className='card-date'>
                          {this.renderDateTime(job.attributes.start_date, job.attributes.end_date)}
                        </div>
                      </div>                
                    </div>
                  </div>
                )
              })
            }
          </div>

        </div>

      </div>
    )
  }

}

export default IncompleteJob;